import React from 'react';
import './TrendedChart.css';

import grabLogo from '../../images/Grab Logo.png';
import ShopeeLogo from '../../images/Shopee.png';
import McdonaldsLogo from '../../images/Mcdonalds.png';
import FoodpandaLogo from '../../images/Foodpanda.png';
import GofoodLogo from '../../images/gofoodLogo18.png';

const TrendedChart = ({ columns = 3,selectedCountry }) => {
  const brands = [
    { name: 'Grab', logo: grabLogo, color: '#4CAF50', data: [30, 50, 45, 60, 70, 65] },
    { name: 'Shopee', logo: ShopeeLogo, color: '#ee4d2d', data: [40, 45, 50, 55, 60, 58] },
    { name: 'Mcdonalds', logo: McdonaldsLogo, color: '#fcb900', data: [35, 40, 38, 45, 50, 48] },
    { name: 'Foodpanda', logo: FoodpandaLogo, color: '#E91E63', data: [25, 30, 35, 40, 42, 45] },
    { name: 'Gofood', logo: GofoodLogo, color: '#E52535', data: [20, 25, 28, 35, 38, 40] },
  ];

  const maxValue = Math.max(...brands.flatMap(b => b.data));
  const chartHeight = 100; // height of chart area

  const renderBrand = (brand) => (
    <div key={brand.name} className="trended-brand-card">
      <div className="trended-brand-header">
        <div className="trended-logo-wrapper">
          <img src={brand.logo} alt={brand.name} className="trended-logo" />
        </div>
        <h3 className="trended-brand-name" style={{ color: brand.color }}>{brand.name}</h3>
      </div>

      <div className="trended-chart">
        {brand.data.map((value, index) => {
          const barHeight = (value / maxValue) * chartHeight;
          return (
            <div
              key={index}
              className="trended-bar"
              style={{
                height: `${barHeight}px`,
                backgroundColor: brand.color
              }}
              title={`Value: ${value}`}
            />
          );
        })}
      </div>
{JSON.stringify(selectedCountry)}
    </div>
  );

  return (
    <div className="trended-container">
      <div className="trended-grid" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
        {brands.map(renderBrand)}
      </div>
    </div>
  );
};

export default TrendedChart;
